import { render, staticRenderFns } from "./ProvenanceNav.vue?vue&type=template&id=127b0585&scoped=true&"
import script from "./ProvenanceNav.vue?vue&type=script&lang=js&"
export * from "./ProvenanceNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b0585",
  null
  
)

export default component.exports